import React from 'react';

interface SchemaProps {
  brand: string | null;
}

function Schema({ brand }: SchemaProps): React.ReactElement | null {
  return brand ? (
    <span itemProp="brand" itemScope itemType="http://schema.org/Organization">
      {brand.length > 0 || <meta itemProp="name" content={brand || 'Beaverbrooks'} />}
    </span>
  ) : null;
}

export default Schema;
